export default "__VITE_ASSET__CTR9NLQs__"